import React, { Component } from "react";
import classnames from "classnames";

import * as styles from "./UsageItem.scss";

export interface IUserItemProps {
    large?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export class UsageItem extends Component<IUserItemProps> {
    public render() {
        const { large, className, children } = this.props;

        return (
            <div
                className={classnames(
                    styles["usage-item"],
                    large && styles.large,
                    className,
                )}
            >
                {children}
            </div>
        );
    }
}
